import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_OUR_WORK_START, DELETE_OUR_WORK_ERROR, DELETE_OUR_WORK_SUCCESS, GET_OUR_WORK_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/our-work/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_OUR_WORK_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_OUR_WORK_ERROR, error });
  } finally {
    yield put({ type: GET_OUR_WORK_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_our_work() {
  yield takeLatest(DELETE_OUR_WORK_START, del);
}
